function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import ReactDOM from "react-dom";
import QRReader from "react-qr-reader";

var ReactQRReaderField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactQRReaderField, _Component);

  function ReactQRReaderField(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleScan", function (data) {
      if (data) {
        console.log(data);

        _this.props.onChange(data);

        _this.setState({
          showScanner: false,
          value: data
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (err) {
      console.error(err);
    });

    _defineProperty(_assertThisInitialized(_this), "supportsWebRTCMedia", function () {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        return false;
      } else return true;
    });

    _defineProperty(_assertThisInitialized(_this), "isiOS", function () {
      return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) // iPad on iOS 13 detection
      || navigator.userAgent.includes("Mac") && "ontouchend" in document;
    });

    _this.state = _extends({}, props, {
      showScanner: false,
      value: null
    });
    return _this;
  }

  var _proto = ReactQRReaderField.prototype;

  _proto._getQRReader = function _getQRReader() {
    var _this2 = this;

    return ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
      style: {
        position: "fixed",
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.5)"
      }
    }, /*#__PURE__*/React.createElement(QRReader, {
      delay: 500,
      onError: this.handleError,
      onScan: this.handleScan,
      className: "QRReader_container",
      style: {
        width: "100%"
      },
      facingMode: "environment"
    }), /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%",
        position: "absolute",
        bottom: 0,
        borderRadius: 0,
        margin: "auto",
        zIndex: 10
      },
      onClick: function onClick() {
        return _this2.setState({
          showScanner: false
        });
      },
      className: "btn btn-block btn-secondary"
    }, "Close")), document.getElementsByTagName("body")[0]);
  };

  _proto.render = function render() {
    var _this3 = this;

    return /*#__PURE__*/React.createElement("span", null, this.state.showScanner ? this._getQRReader() : /*#__PURE__*/React.createElement("span", null, this.state.value && /*#__PURE__*/React.createElement("span", {
      className: "mr-2"
    }, this.state.value), this.isiOS() && !this.supportsWebRTCMedia() ? /*#__PURE__*/React.createElement("button", {
      className: "btn btn-sm btn-outline-danger",
      onClick: function onClick(e) {
        e.preventDefault();
        alert("This browser does not support the camera. On iPhone, use Safari.");
      }
    }, "QR") : /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return _this3.setState({
          showScanner: true
        });
      },
      className: "btn btn-sm btn-secondary"
    }, "QR"), this.state.value && /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        var clearValue = confirm("Are you sure?");
        if (clearValue) _this3.setState({
          value: null
        });
      },
      className: "btn btn-sm btn-secondary ml-1"
    }, "\xD7")));
  };

  return ReactQRReaderField;
}(Component);

export default ReactQRReaderField;